import React from "react";
import Button, { ButtonType } from "../Assets/Button";
import toast from "react-hot-toast";

interface CoApplicantModalProps {
  isOpen: boolean;
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

const CoApplicantModal: React.FC<CoApplicantModalProps> = ({
  isOpen,
  value,
  onChange,
  onCancel,
  onConfirm,
}) => {
  const hanleAddCoApplicant = () => {
    onConfirm();
    toast.success("Co-applicant name added successfully");
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg w-full max-w-sm p-4">
        <h3 className="text-sm font-semibold mb-3">Add Co-Applicant Name</h3>

        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter name"
          className="w-full text-sm border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          autoFocus
        />

        <div className="flex justify-end gap-2">
          <Button
            type={ButtonType.Cancel}
            onClick={onCancel}
            className="text-xs"
          >
            Cancel
          </Button>

          <Button
            type={ButtonType.Submit}
            onClick={hanleAddCoApplicant}
            className="text-xs"
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CoApplicantModal;
